// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"xL3tcY_uKlEAW2ZvOBlZR"};